import {errorNotification} from '../helpes/notification';

export const AlertError = ( actions, message )=>{

    errorNotification(actions, message);
    return''
}